import { Payment } from '@lc/interface/payment/types';
import { Player } from '@lc/interface/player/types';
import { energyColors } from '@lc/types/Misc';

export default class PaymentAction {
	deletePaymentFromEnergyArray(
		playerEnergyArray: string[],
		paymentEnergyArray: string[]
	) {
		for (const energyChar of paymentEnergyArray) {
			// delete first instance of energy char starting from right side of array
			for (let i = playerEnergyArray.length - 1; i >= 0; i--) {
				if (playerEnergyArray[i] === energyChar) {
					playerEnergyArray.splice(i, 1);
					break;
				}
			}
		}
	}

	getPaymentObjectTotal(paymentObject: Payment) {
		let total = 0;

		if (paymentObject?.factoryEnergyArr.length > 0) {
			total += paymentObject.factoryEnergyArr.length;
		}

		if (paymentObject?.batteryEnergyArr.length > 0) {
			total += paymentObject.batteryEnergyArr.length;
		}

		total += paymentObject.carbonReserve;

		return total;
	}

	// if player has at least requested factory energy, battery energy and carbon, return true
	isPaymentValid(player: Player, paymentObject: Payment) {
		// check if player has AT LEAST energy requested. 0 === 0 is fine.
		// TODO add payment modifiers
		if (
			paymentObject?.factoryEnergyArr &&
			!this.verifyPaymentObjectArray(
				player.factoryEnergyArr,
				paymentObject.factoryEnergyArr
			)
		) {
			return false;
		}
		if (
			paymentObject?.batteryEnergyArr &&
			!this.verifyPaymentObjectArray(
				player.batteryEnergyArr,
				paymentObject.batteryEnergyArr
			)
		)
			return false;

		if (player.carbonReserve < paymentObject.carbonReserve) {
			return false;
		}

		return true;
	}

	// remove energy from factory and battery EnergyArr, also carbon
	payForAction(player: Player, paymentObject: Payment) {
		this.deletePaymentFromEnergyArray(
			player.factoryEnergyArr,
			paymentObject.factoryEnergyArr
		);
		this.deletePaymentFromEnergyArray(
			player.batteryEnergyArr,
			paymentObject.batteryEnergyArr
		);

		player.carbonReserve -= paymentObject.carbonReserve;
		player.carbonFootprint += paymentObject.carbonReserve;
	}

	undoPayForAction(player: Player, paymentObject: Payment) {
		for (const energyColor of paymentObject.factoryEnergyArr) {
			player.factoryEnergyArr.push(energyColor);
		}
		for (const energyColor of paymentObject.batteryEnergyArr) {
			player.batteryEnergyArr.push(energyColor);
		}

		player.carbonReserve += paymentObject.carbonReserve;
		player.carbonFootprint -= paymentObject.carbonReserve;
	}

	verifyPaymentObjectArray(
		playerEnergyArray: energyColors[],
		paymentEnergyArray: energyColors[]
	) {
		if (paymentEnergyArray == null || paymentEnergyArray.length < 1)
			return true;

		const energyMap = new Map();
		energyMap.set('r', 0);
		energyMap.set('g', 0);
		energyMap.set('b', 0);
		energyMap.set('y', 0);

		for (const energyChar of playerEnergyArray) {
			if (!energyMap.has(energyChar)) return false;
			energyMap.set(energyChar, energyMap.get(energyChar) + 1);
		}

		for (const energyChar of paymentEnergyArray) {
			if (!energyMap.has(energyChar)) return false;
			let energyCount = energyMap.get(energyChar);
			if (energyCount < 0) return false;
			energyMap.set(energyChar, --energyCount);
		}

		return true;
	}

	/** TODOTODO
	 * tests all player's summit cards. If one reaches the condition to be played, return true
	 * @param player
	 * @returns
	 */
	atLeastOneSummitCardPlayable(player: Player) {
		return true;
	}
}

export const act_payment = new PaymentAction();
